import {connect} from 'react-redux';
import FirmLogo from './FirmLogo';

const mapStateToProps = ({
                           user: {firmLogo}
                         }) => ({
  firmLogo
});

export default connect(
  mapStateToProps,
  null
)(FirmLogo);
